import React from "react";

const HeroSection = () => {
  return (
    <section className="bg-black h-screen flex items-center justify-center relative">
      <div className="w-full mx-auto px-8 flex items-center justify-center">
        <div className="relative w-full max-w-none">
          <img
            src="/images/logo.png"
            alt="emdash logo"
            className="w-auto h-auto max-w-[90vw] max-h-[80vh] object-contain mx-auto block"
            style={{
              filter: 'brightness(0) invert(1)',
              transform: 'scale(2)'
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;